import * as React from 'react';
import { render } from 'react-dom';

interface IProps {
    startTime: Date;
}

export class Clock extends React.Component<IProps, any> {
    private id: string = '-' + Math.random();

    constructor(props: IProps) {
        super(props);

        this.state = {
            ...props
        };
    }

    componentDidMount() {
        this.clock(this.id);

        if (this.state.startTime) {
            setInterval(this.clock.bind(this), 1000, this.id);
        }
    }

    clock(id: string): void {
        // calculate angle
        let d: Date;
        let h, m, s;
        d = new Date(this.state.startTime);
        d.setSeconds(d.getSeconds() + 1);

        this.setState({
            startTime: d
        });

        h = 30 * ((d.getHours() % 12) + d.getMinutes() / 60);
        m = 6 * d.getMinutes();
        s = 6 * d.getSeconds();

        // move hands
        this.setAttr('h-hand' + id, h);
        this.setAttr('m-hand' + id, m);
        this.setAttr('s-hand' + id, s);
        this.setAttr('s-tail' + id, s + 180);

        // display time
        h = d.getHours();
        m = d.getMinutes();
        s = d.getSeconds();

        this.setText('sec' + id, s);
        this.setText('min' + id, m);
        this.setText('hr' + id, h);
    }

    setAttr(id, val) {
        let v = 'rotate(' + val + ', 70, 70)';
        document.getElementById(id).setAttribute('transform', v);
    }

    setText(id, val) {
        if (val < 10) {
            val = '0' + val;
        }
        document.getElementById(id).innerHTML = val;
    }

    render() {
        return (
            <div class="analog-clock">
                <svg width="140" height="140" className="white">
                    <circle id="clock-face" cx="70" cy="70" r="65" />
                    <line id={'h-hand' + this.id} x1="70" y1="70" x2="70" y2="38" />
                    <line id={'m-hand' + this.id} x1="70" y1="70" x2="70" y2="20" />
                    <line id={'s-hand' + this.id} x1="70" y1="70" x2="70" y2="12" />
                    <line id={'s-tail' + this.id} x1="70" y1="70" x2="70" y2="56" />
                    <text fill="white" x="62" y="18">
                        12
                    </text>
                    <text fill="white" x="126" y="76">
                        3
                    </text>
                    <text fill="white" x="66" y="130">
                        6
                    </text>
                    <text fill="white" x="7" y="76">
                        9
                    </text>
                </svg>
                <div class="time-text">
                    <span id={'hr' + this.id}>00</span>
                    <span>:</span>
                    <span id={'min' + this.id}>00</span>
                    <span>:</span>
                    <span id={'sec' + this.id}>00</span>
                </div>
            </div>
        );
    }
}

export default Clock;
